import { autoRouteTable } from "@/router/constants/auto-route-table";
import { FUNNEL_START_PAGE } from "@/router/constants/routes";
import { checkPagePrerequisites } from "@/router/methods/page-prerequisites";
import { debugLog } from "@/helpers/debug-log-helper";

export async function autoRouteBeforeEnter(to, from) {
    debugLog(`--- auto-route.js start to ${to.name} from ${from.name} ---`);
    for (let i = 0; i < autoRouteTable.length; i++) {
        const testRouteData = autoRouteTable[i];
        debugLog(`--- auto-route.js testing route: ${testRouteData.name} ---`);

        // Check if the route's own arePagePrerequisitesValid are met.
        const arePrerequisitesMet = await checkPagePrerequisites(testRouteData.name);
        debugLog(
            `--- auto-route.js prerequisites met: ${arePrerequisitesMet} for ${testRouteData.name} ---`
        );

        if (arePrerequisitesMet) {
            // Check isEligible, an additional condition some routes layer on top of arePagePrerequisitesValid.
            const isEligible = testRouteData.isEligible ? await testRouteData.isEligible() : true;
            debugLog(`--- auto-route.js eligible: ${isEligible} for ${testRouteData.name} ---`);
            if (isEligible) {
                return {
                    name: testRouteData.name,
                    replace: true,
                };
            }
        }
    }

    debugLog(`--- auto-route.js no eligible route found, returning to funnel start page ---`);
    return {
        name: FUNNEL_START_PAGE,
        replace: true,
    };
}
